'use client'

// @ts-strict-ignore
import React, { memo, useEffect, useState } from 'react'

import { FilterValue } from '@/entities/catalog-old/schema/filter.schema'

import { Collapse } from '@/shared/ui/collapse'

import { getFilteredProperties } from '../../lib/get-filtered-properties'
import { SearchField } from '../search-field/search-field'

import { CheckboxList } from './checkbox-list/checkbox-list'
import { ShowMoreButton } from './show-more-button/show-more-button'
import { TopPanel } from './top-panel/top-panel'

import cls from './accordion-filter.module.scss'

export type AccordionFilterProps = {
	defaultOpen?: boolean
	name: string
	code: string
	items: FilterValue[]
	isDisabled?: boolean
}

export const AccordionFilter = memo((props: AccordionFilterProps) => {
	const { defaultOpen, name, items, code, isDisabled } = props
	const [searchValue, setSearchValue] = useState('')
	const [isAllVisible, setIsAllVisible] = useState(false)
	const [openSub, setOpenSub] = useState(defaultOpen)
	const [haveCheckedValues, setHaveCheckedValues] = useState(false)
	const [filteredProperties, setFilteredProperties] = useState<FilterValue[]>([])
	const filterHasManyOptions = items?.length > 5
	const hasSearchedResults = filteredProperties.length > 0

	useEffect(() => {
		const newFilteredProperties = searchValue ? getFilteredProperties(items, searchValue) : items
		setFilteredProperties(newFilteredProperties)
	}, [items, searchValue])

	useEffect(() => {
		const haveCheckedValues = items.some(value => value.CHECKED)
		setHaveCheckedValues(haveCheckedValues)
	}, [items])

	return (
		<div className={cls.root}>
			<TopPanel open={openSub} withMark={haveCheckedValues} name={name} onClick={() => setOpenSub(!openSub)} />
			<Collapse open={openSub}>
				<div className={cls.inner}>
					{filterHasManyOptions && (
						<SearchField
							value={searchValue}
							onChange={evt => setSearchValue(evt.currentTarget.value)}
							ariaLabel={`Поиск по значениям свойства «${name}»`}
							isDisabled={isDisabled}
						/>
					)}
					<div className={cls.checkboxListWrap}>
						{hasSearchedResults && (
							<CheckboxList items={filteredProperties} name={code} isDisabled={isDisabled} open={isAllVisible} />
						)}
					</div>
					{hasSearchedResults && filterHasManyOptions && (
						<ShowMoreButton isActive={isAllVisible} onClick={() => setIsAllVisible(!isAllVisible)} />
					)}
					{!hasSearchedResults && <p className={cls.emptyMsg}>Ничего не нашлось</p>}
				</div>
			</Collapse>
		</div>
	)
})
